export default {"src":"__ASTRO_ASSET_IMAGE__HF4qV0PL__","width":172,"height":144,"format":"svg"}